import { Backdrop, Fade, Modal as MuiModal } from "@mui/material";
import MuiCard from "@mui/material/Card";
import {
  MODAL_BASE_STYLE,
  MODAL_FADE_TIMEOUT,
  MODAL_FIT_STYLE,
  MODAL_LARGE_STYLE,
  MODAL_SLOT_PROPS,
} from "./Modal.constants";
import type { ModalProps } from "./Modal.types";

export default function Modal({
  isOpen,
  onClose,
  size = "large",
  sx = {},
  slotProps,
  slots,
  closeAfterTransition = true,
  testId,
  onExited,
  children,
  ...modalProps
}: ModalProps) {
  const baseStyle = size === "fit" ? MODAL_FIT_STYLE : MODAL_LARGE_STYLE;
  const mergedStyle = {
    ...MODAL_BASE_STYLE,
    ...baseStyle,
    ...(!isOpen && { transition: "none" }),
    ...sx,
  };

  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
      closeAfterTransition={closeAfterTransition}
      slots={{ backdrop: Backdrop, ...slots }}
      slotProps={{ ...MODAL_SLOT_PROPS, ...slotProps }}
      {...modalProps}
    >
      <Fade in={isOpen} timeout={MODAL_FADE_TIMEOUT} onExited={onExited}>
        <MuiCard sx={mergedStyle} data-test-id={testId}>
          {children}
        </MuiCard>
      </Fade>
    </MuiModal>
  );
}
